<template>
  <div class="bg-white p-4 rounded shadow-sm">
    <!-- Mensagem de sucesso caso a api retorne 200 -->
    <success
      :control="controlSuccess"
      :msg="
        '<strong>Recebemos sua mensagem!</strong><br>Entraremos em contato em breve.'
      "
      data-aos="fade-in-zoom"
      data-aos-once="true"
    />

    <!-- Mensagem em caso de erro na api -->
    <error
      :control="controlError"
      :msg="'Erro na solicitação. Por favor, tente novamente.'"
      data-aos="fade-in-zoom"
      data-aos-once="true"
    />

    <h5 class="text-secondary text-center font-weight-normal">
      <strong>Cadastre seu veículo</strong> e nossos consultores entrarão em
      <strong>contato</strong>
    </h5>

    <form class="mt-4 px-3 d-flex flex-column align-items-center">
      <b-form-group class="w-100 mt-0">
        <input type="text" v-model="nome" required="required" />
        <label for="input" class="control-label" style="font-size: 90%;">Nome</label>
        <i class="bar"></i>
        <div class="invalid-feedback" :class="{ 'd-flex': nomeFeed }">Campo obrigatório</div>
      </b-form-group>

      <b-form-group class="w-100 mt-1">
        <input type="tel" v-model="telefone" v-mask="'(##) # ####-####'" required="required" />
        <label for="input" class="control-label" style="font-size: 90%;">Telefone</label>
        <i class="bar"></i>
        <div class="invalid-feedback" :class="{ 'd-flex': telefoneFeed }">Campo obrigatório</div>
      </b-form-group>

      <b-form-group class="w-100 mt-1">
        <input type="text" v-model="cidade" required="required" />
        <label for="input" class="control-label" style="font-size: 90%;">Cidade</label>
        <i class="bar"></i>
        <div class="invalid-feedback" :class="{ 'd-flex': cidadeFeed }">Campo obrigatório</div>
      </b-form-group>

      <b-form-group class="w-100 mt-1">
        <input type="text" v-model="modelo" required="required" />
        <label for="input" class="control-label" style="font-size: 90%;">Veículo, ano</label>
        <i class="bar"></i>
        <div class="invalid-feedback" :class="{ 'd-flex': veiculoFeed }">Campo obrigatório</div>
      </b-form-group>

      <!--<div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
        <label>
          <input type="checkbox" @click="active = !active" />
          <i class="helper" style="top: 3px;"></i>Li e concordo com as regras
        </label>
        <div
          class="invalid-feedback"
          :class="{ 'd-inline-block': termosFeed }"
        >Obrigatório ler e concordar com os termos</div>
      </div>-->

      <div class="d-flex flex-wrap justify-content-center">
        <b-button
          variant="purple"
          v-html="textSubmit"
          :disabled="stateSubmit"
          @click.prevent="sendLead"
          class="text-uppercase text-white px-5 py-2 my-3"
        />
        <router-link
          v-if="this.$route.path !== '/'"
          to="/"
          class="btn-light text-secondary text-uppercase text-white px-4 d-flex align-items-center py-2 mb-5 ml-2"
        >
          <i class="fas fa-angle-left mr-2"></i>
          voltar ao home
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Success from "@/components/Success.vue";
import Error from "@/components/Error.vue";

import { VueMaskDirective } from "v-mask";

import axios from "axios";

import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

export default {
  directives: {
    mask: VueMaskDirective
  },
  components: {
    Success,
    Error
  },
  data: () => {
    return {
      nomeFeed: false,
      telefoneFeed: false,
      cidadeFeed: false,
      veiculoFeed: false,
      termosFeed: false,
      controlSuccess: false,
      controlError: false,
      textSubmit: "quero vender meu veículo",
      stateSubmit: false,
      active: false,
      nome: "",
      telefone: "",
      cidade: "",
      modelo: ""
    };
  },
  computed: {
    ...mapState(["EMAIL_API"])
  },
  methods: {
    validateForm() {
      let a = "";
      if (this.nome.length == 0) {
        this.nomeFeed = true;
        a = "1";
      } else {
        this.nomeFeed ? (this.nomeFeed = false) : "";
      }

      if (this.telefone.length == 0) {
        this.telefoneFeed = true;
        a = "1";
      } else {
        this.telefoneFeed ? (this.telefoneFeed = false) : "";
      }

      if (this.cidade.length == 0) {
        this.cidadeFeed = true;
        a = "1";
      } else {
        this.cidadeFeed ? (this.cidadeFeed = false) : "";
      }

      if (this.modelo.length == 0) {
        this.veiculoFeed = true;
        a = "1";
      } else {
        this.veiculoFeed ? (this.veiculoFeed = false) : "";
      }

      /*if (this.active === false) {
        this.termosFeed = true;
        a = "1";
      } else {
        this.termosFeed ? (this.termosFeed = false) : "";
      }
      */
      if (a === "1") return false;
    },
    async sendLead() {
      // Realizando validação no formulário antes da engine
      if (this.validateForm() === false) return false;

      // Mudando o estado do botão de submit
      this.textSubmit =
        '<div class="spinner-border spinner-border-sm text-light mr-2" role="status"><span class="sr-only">Loading...</span></div>enviando...';
      this.stateSubmit = true;

      let self = this;
      await axios
        .post(`${self.EMAIL_API.API_URL}/mail`, {
          headers: {
            "Content-Type": "application/json"
          },
          params: {
            to: self.EMAIL_API.TO,
            cc: "ycarorafael@gmail.com,alisonvilasboas@gmail.com",
            title: "Vaapty - Lead vindo do site",
            data: [
              {
                legend: "Nome",
                desc: self.nome
              },
              {
                legend: "Telefone",
                desc: self.telefone
              },
              {
                legend: "Cidade",
                desc: self.cidade
              },
              {
                legend: "Veículo",
                desc: self.modelo
              }
            ],
            host_body: {
              Name: self.EMAIL_API.HOST_NAME,
              Port: self.EMAIL_API.PORT,
              User: self.EMAIL_API.USER,
              Pass: self.EMAIL_API.PASS
            }
          }
        })
        .then(() => {
          // Habilitando mensagem de sucesso
          self.controlSuccess = true;

          setTimeout(() => {
            this.$router.push("obrigado");
            self.controlSuccess = false;
          }, 3000);

          // Zerando o estado dos inputs
          self.nome = "";
          self.telefone = "";
          self.cidade = "";
          self.modelo = "";
          self.active = false;
        })
        .catch(() => {
          this.controlError = true;
          setTimeout(() => {
            self.controlError = false;
          }, 4000);
        });

      // Retornando ao estado original do botão pós envio de formulário
      this.textSubmit = "quero vender meu veículo";
      this.stateSubmit = false;
    }
  }
};
</script>
